export default __webpack_public_path__ + "static/automatische-cfb5f8bb9e733cdb998e6b9f213be721408e3216c212ced17445e3010e180cd7.png";